"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/IntranetHeader";
import Footer from "../../components/Footer";

// -------------------------
// Resource JSON
// -------------------------
const resourceData = [
  {
    section: "Policies & Documents",
    resources: [
      {
        title: "RUHT | Nursing Scope of Practice",
        url: "https://docs.google.com/spreadsheets/d/1Lr9Nn6YmYxkHnAupxjm1bZGhQQcRrGikIPdWcVPWT_U/edit?usp=sharing",
        description:
          "Nursing professional boundaries, allowed duties, and escalation guidance.",
        external: true,
      },
      {
        title: "Anesthetia Crisis Guidelines",
        url: "https://rcoa.ac.uk/sites/default/files/documents/2019-11/qrh_complete_august_2019.pdf",
        description:
          "Quick reference handbook to the Anesthetia Crisis Guidelines.",
        external: true,
      },
      {
        title: "Foundation Year | Personal Development Plan",
        url: "https://docs.google.com/document/d/1S8WIwU32iGt29O1CzJZJC1vo8a9tkKGL1SPqlhHqX2I/edit?tab=t.0",
        description: "Nursing Personal Development Plan template.",
        external: true,
      },
      {
        title: "Nursing | Personal Development Plan",
        url: "https://docs.google.com/document/d/1tOpefkspwrzzg4e_tjNyjlWiAP4xPCkni526pdiFbQA/edit?tab=t.0",
        description: "Nursing Personal Development Plan template.",
        external: true,
      },
      {
        title: "NHS Safeguaridng",
        url: "https://docs.google.com/document/d/15xeiS1fp3Q4Pxw-ahILsO94Bsc-wSOGgidrNFC4c-mc/edit?usp=sharing",
        description: "Quick reference to NHS safeguarding guidelines.",
        external: true,
      },
    ],
  },
  {
    section: "Support & Tools",
    resources: [
      {
        title: "Drug Matrix",
        url: "/intranet/drug-matrix",
        description: "Search medicines by drug name, predefined category and administration label.",
        external: false,
        buttonLabel: "Open Drug Matrix",
      },
      {
        title: "NEWS2 Calculator",
        url: "/intranet/news2-calculator",
        description: "Tool to calculate National Early Warning Scores.",
        external: false,
      },
    ],
  },
];

export default function Resources() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <main
        className="nhsuk-width-container nhsuk-u-padding-top-6 nhsuk-u-padding-bottom-6"
        style={{ fontFamily: "Frutiger" }}
      >
        <h1 className="nhsuk-heading-xl">Staff Resources</h1>
        <p className="nhsuk-body-l nhsuk-u-margin-bottom-5">
          Your hub for essential RUHT staff tools, documents, training, and
          links.
        </p>

        {resourceData.map((section, sIdx) => (
          <div key={sIdx} className="mb-6">
            <h2 className="nhsuk-heading-l">{section.section}</h2>

            <div className="resources-grid">
              {section.resources.map((res, rIdx) => (
                <div
                  key={rIdx}
                  className="nhsuk-card"
                  style={
                    section.section === "Support & Tools"
                      ? {
                          border: "1px solid var(--nhs-mid-grey)",
                          borderRadius: "1rem",
                        }
                      : {}
                  }
                >
                  <div className="nhsuk-card__content">
                    {res.external ? (
                      <h3 className="nhsuk-heading-s">
                        <a
                          className="nhsuk-link"
                          href={res.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {res.title}
                        </a>
                      </h3>
                    ) : (
                      <h3 className="nhsuk-heading-s">
                        <button type="button" className="pguh-resource-title-button" onClick={() => navigate(res.url)}>
                          {res.title}
                        </button>
                      </h3>
                    )}
                    <p className="nhsuk-body-s">{res.description}</p>
                    {!res.external && res.buttonLabel && (
                      <button type="button" className="nhsuk-button nhsuk-button--secondary nhsuk-u-margin-bottom-0" onClick={() => navigate(res.url)}>
                        {res.buttonLabel}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </main>

      <Footer />
    </>
  );
}
